'use client';

import React from 'react';
import classes from '@/components/shop/shop-home.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/lib/store';
import { setShopSortOrder } from '@/slice/shopSlice';

function ShopSortTab({
  dict: {
    sortSuggestion,
    sortPopularity,
    sortRecently,
    sortLowPrice,
    sortHighPrice,
  },
}: {
  dict: {
    sortSuggestion: string;
    sortPopularity: string;
    sortRecently: string;
    sortLowPrice: string;
    sortHighPrice: string;
  };
}) {
  const dispatch = useDispatch();
  const tabName = useSelector((state: RootState) => state.shop.tabName);
  const sortTabName = useSelector((state: RootState) => state.shop.sortOrder);

  const handleChangeTab = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newName = e.target.value;
    if (
      ['newest', 'lowPrice', 'highPrice', 'popularity'].indexOf(newName) !== -1
    ) {
      dispatch(
        setShopSortOrder(
          newName as 'newest' | 'lowPrice' | 'highPrice' | 'popularity',
        ),
      );
    }
  };

  return (
    <div className={classes.alignList}>
      <div className={classes.alignItem}>
        <label>
          <input
            type="radio"
            name="sort"
            value="popularity"
            checked={sortTabName === 'popularity' && true}
            onChange={handleChangeTab}
          />
          <span className={classes.txt}>{sortPopularity}</span>
        </label>
      </div>
      <div className={classes.alignItem}>
        <label>
          <input
            type="radio"
            name="sort"
            value="newest"
            checked={sortTabName === 'newest' && true}
            onChange={handleChangeTab}
          />
          <span className={classes.txt}>{sortRecently}</span>
        </label>
      </div>
      <div className={classes.alignItem}>
        <label>
          <input
            type="radio"
            name="sort"
            value="lowPrice"
            checked={sortTabName === 'lowPrice' && true}
            onChange={handleChangeTab}
          />
          <span className={classes.txt}>{sortLowPrice}</span>
        </label>
      </div>
      <div className={classes.alignItem}>
        <label>
          <input
            type="radio"
            name="sort"
            value="highPrice"
            checked={sortTabName === 'highPrice' && true}
            onChange={handleChangeTab}
          />
          <span className={classes.txt}>{sortHighPrice}</span>
        </label>
      </div>
    </div>
  );
}

export default ShopSortTab;
